import { render } from "./DownloadProForma.vue?vue&type=template&id=422822c3&scoped=true"
import script from "./DownloadProForma.vue?vue&type=script&lang=js"
export * from "./DownloadProForma.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422822c3"]])

export default __exports__